import { BaseDatasource } from '@/shared/resources/datasources/base-datasource'
import {
    CommonFilterModel,
    CommonParams,
    CommonSortModelResource,
    ExportCommonParams
} from '@/api/resources/common/shared/models/common.models'
import { AgColumnDefinition, IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { GridUtils } from '@/shared/util/grid-utils'
import { ReportGridRequest } from '@/api/services/common.dto'
import { AxiosResponse } from 'axios'

export abstract class ColumnDatasource<T> extends BaseDatasource<T> {
    protected abstract fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<T>>

    protected paginator(
        filterModel: CommonFilterModel,
        sortModel: CommonSortModelResource[],
        page: number,
        size: number
    ): Promise<IResponseAgGrid<T>> {
        const params: CommonParams = {
            sort: GridUtils.getSortValue(sortModel),
            page,
            size
        }
        return this.fetchData(filterModel, params)
    }

    ///

    public getColumnDefs?(): AgColumnDefinition[]
    public get columnDefs(): AgColumnDefinition[] {
        return this.getColumnDefs ? this.getColumnDefs() : []
    }

    public exporter?(request: ReportGridRequest, params: ExportCommonParams): Promise<AxiosResponse<Blob>>
}
